import s from "./_common.js";
import a from "../../_styles/common/light.js";
function c(o) {
  const {
    boxShadow2: r,
    popoverColor: t,
    textColor2: e,
    borderRadius: i,
    fontSize: n,
    dividerColor: m
  } = o;
  return Object.assign(Object.assign({}, s), {
    fontSize: n,
    borderRadius: i,
    color: t,
    dividerColor: m,
    textColor: e,
    boxShadow: r
  });
}
const p = {
  name: "Popover",
  common: a,
  self: c
}, b = p;
export {
  b as default,
  c as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popover/styles/light.js
// module id = 203
// module chunks = 41